import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudConfirmacion from './NuevaSolicitudConfirmacion';

//Importación de actions.
import {
    GetScreenData,
    routeToNext,
    routingPrevious,
    routeToCancel,
    guardarSolicitud,
    finalizarSolicitud,
    resetStateSolicitudConfirmacion

} from '../actions/NuevaSolicitudConfirmacionActions';

const mapStateToProps = (state) => {
    return {
        data: state.confirmacion.data,
        tarjetas: state.tarjetas,
        sesion: state.sesion,
        isFetching: state.confirmacion.isFetching,
        error: state.confirmacion.error
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        GetScreenData: (state, currentScope, tarjetas, sesion) => {
            dispatch(GetScreenData(state, currentScope, tarjetas, sesion));
        },
        routeToNext: () => {
            dispatch(routeToNext());
        },
        routingPrevious: (request) => {
            dispatch(routingPrevious(request));
        },
        routeToCancel: (request) => {
            dispatch(routeToCancel(request));
        },
        guardarSolicitud: (request) => {
            dispatch(guardarSolicitud(request));
        },
        finalizarSolicitud: () => {
            dispatch(finalizarSolicitud());
        },
        resetStateSolicitudConfirmacion: () => {
            dispatch(resetStateSolicitudConfirmacion());
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudConfirmacionContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudConfirmacion);

export default NuevaSolicitudConfirmacionContainer;